var CustomArrowButtonDirections = /* @__PURE__ */ ((CustomArrowButtonDirections2) => {
  CustomArrowButtonDirections2[CustomArrowButtonDirections2["up"] = 0] = "up";
  CustomArrowButtonDirections2[CustomArrowButtonDirections2["down"] = 1] = "down";
  return CustomArrowButtonDirections2;
})(CustomArrowButtonDirections || {});
export {
  CustomArrowButtonDirections
};
//# sourceMappingURL=custom-arrow-button.interface.es.js.map
